export const Marker = ({ pointObj, clickedMarkers, selectedMarker }: any) => {
    const isCluster = pointObj?.properties?.cluster;
    const clusterData = pointObj?.properties?.pointsData;
    const clusterCount = pointObj?.properties?.point_count ?? 1;
    const propID = pointObj?.properties?.propID;
    const pointType = pointObj?.properties?.pointType;
    const clusterID = pointObj?.properties?.randomID;
    const isClicked = clickedMarkers.includes(propID) ||
        clickedMarkers.includes(clusterID) ||
        (isCluster && clusterData.some((point) => clickedMarkers.includes(point.propID)));
    const isSelectedInCluster = isCluster && clusterData.some((point) => point.propID === selectedMarker) || selectedMarker == clusterID;

    return (
        <div className="mapMarker_wrapp">
            {isCluster ? (
                <div data-prop-id={clusterID ?? ''} className={`${isClicked ? 'clicked' : ''} ${isSelectedInCluster ? 'currentMarket' : ''} mapMarker_cluster`}>{clusterCount}</div>
            ) : (
                <>
                    {pointType !== 1 ? (
                        <div
                            data-prop-id={propID ?? ''}
                            className={`mapMarker ${isClicked ? 'clicked' : ''} ${selectedMarker == propID ? 'currentMarket' : ''}`}
                        />
                    ) : (
                        <div
                            data-prop-id={propID ?? ''}
                            className={`mapMarkerRadius ${isClicked ? 'clicked' : ''} ${selectedMarker == propID ? 'currentMarket' : ''}`}
                        />
                    )}
                </>
            )}
        </div>
    );
};